// Mock data for United ELD LLC website

export const companyInfo = {
  name: "United ELD LLC",
  tagline: "Electronic Logging Solutions",
  logo: "https://customer-assets.emergentagent.com/job_6d524a22-dc8b-41b2-b4a0-5db82483e1fa/artifacts/4vxjfb2n_united_eld_logo_white_outline_thin.png",
  phone: "+1 307 456 1239",
  email: "info@unitedeldllc.com",
  address: "75 East 3rd Street, Sheridan, WY 82801",
  workingHours: "8am - 4pm",
  copyright: `© ${new Date().getFullYear()} United ELD LLC. All rights reserved.`
};

export const heroContent = {
  title: "United ELD LLC — ELD Made Simple for Trucking",
  subtitle: "Keep your Hours of Service organized, reduce paperwork, and stay ready for inspections with an ELD solution built for everyday drivers and dispatch.",
  primaryCTA: "Request a Demo",
  secondaryCTA: "Contact Us"
};

export const eldBenefits = [
  {
    id: 1,
    title: "Easier HOS Tracking",
    description: "HOS tracking that's easier to manage than paper logs"
  },
  {
    id: 2,
    title: "Inspection Ready",
    description: "Cleaner inspection readiness with organized records and reports"
  },
  {
    id: 3,
    title: "Less Admin Time",
    description: "Less admin time for drivers and office staff"
  },
  {
    id: 4,
    title: "Better Visibility",
    description: "Better visibility between driver and dispatch"
  },
  {
    id: 5,
    title: "Fewer Mistakes",
    description: "Fewer mistakes from manual logging and paperwork"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Simple Setup",
    description: "Simple setup & onboarding"
  },
  {
    id: 2,
    title: "Driver-Friendly",
    description: "Driver-friendly experience (easy to learn, easy to use)"
  },
  {
    id: 3,
    title: "Responsive Support",
    description: "Responsive support when you need help"
  },
  {
    id: 4,
    title: "Great Fit",
    description: "Great fit for owner-operators and fleets"
  },
  {
    id: 5,
    title: "Reliable Tools",
    description: "Reliable tools designed for real-world trucking"
  }
];

export const ctaContent = {
  text: "Want to see how it works? Contact United ELD LLC for pricing and a quick walkthrough.",
  buttonText: "Get Started Today"
};

export const contactPageContent = {
  title: "Contact Us",
  subtitle: "Get in touch with United ELD LLC",
  demoText: "Schedule an ELD demo with United ELD LLC. We can meet in person (by appointment), set up a Zoom call, or do a quick phone walkthrough. Send us a message and we'll confirm a time that works for you."
};
